import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      if (token) {
        try {
          const res = await api.get('/auth/me');
          setUser(res.data);
        } catch (e) {
          console.error("Failed to fetch user", e);
          localStorage.removeItem('token');
          sessionStorage.removeItem('token');
        }
      }
      setLoading(false);
    };
    fetchUser();
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('token', userData.token);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
  };

  const hasPermission = (permissionName) => {
    if (user?.role === 'Admin') return true;
    return user?.permissions?.includes(permissionName) || false;
  };

  const hasFeature = (featureName) => {
    if (user?.role === 'Admin') return true;
    return user?.features?.includes(featureName) || false;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, hasPermission, hasFeature, isAuthenticated: !!user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

